import React, { useState } from "react";
import {
  Button,
  Stack,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { handleFetch } from "src/api";
import { endPoints } from "src/shared/model";

export const ContactForm: React.FC = () => {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down("lg"));

  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setName(value);
  };

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setEmail(value);
  };

  const handleChangeCompany = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setCompany(value);
  };

  const handleChangeMessage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setMessage(value);
  };

  const handleSubmit = async () => {
    await handleFetch<
      undefined,
      {
        name: string;
        email: string;
        company: string;
        message: string;
      }
    >(endPoints.contact, "POST", {
      name,
      email,
      company,
      message,
    });

    setName("");
    setEmail("");
    setCompany("");
    setMessage("");
  };

  return (
    <Stack
      width={1}
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
      border={1}
      borderRadius={4}
      borderColor="secondary.main"
      padding={4}
    >
      <TextField
        label="Your Name"
        variant="outlined"
        color="secondary"
        placeholder="Name"
        size={isMedium ? "small" : "medium"}
        onChange={handleChangeName}
        value={name}
        fullWidth
        required
        focused
        slotProps={{
          inputLabel: {
            sx: {
              "&.Mui-focused": {
                color: "primary.main",
              },
            },
          },
        }}
      />
      <TextField
        label="Your Email"
        variant="outlined"
        color="secondary"
        placeholder="Email"
        size={isMedium ? "small" : "medium"}
        onChange={handleChangeEmail}
        value={email}
        fullWidth
        required
        focused
        slotProps={{
          inputLabel: {
            sx: {
              "&.Mui-focused": {
                color: "primary.main",
              },
            },
          },
        }}
      />
      <TextField
        label="Your Company"
        variant="outlined"
        color="secondary"
        placeholder="Company name"
        size={isMedium ? "small" : "medium"}
        onChange={handleChangeCompany}
        value={company}
        fullWidth
        focused
        slotProps={{
          inputLabel: {
            sx: {
              "&.Mui-focused": {
                color: "primary.main",
              },
            },
          },
        }}
      />
      <TextField
        label="Your Message"
        variant="outlined"
        color="secondary"
        placeholder="Write anything"
        onChange={handleChangeMessage}
        value={message}
        fullWidth
        required
        focused
        multiline
        minRows={isMedium ? 3 : 4}
        maxRows={isMedium ? 6 : 8}
        slotProps={{
          inputLabel: {
            sx: {
              "&.Mui-focused": {
                color: "primary.main",
              },
            },
          },
        }}
      />

      <Button
        color="primary"
        variant="contained"
        size={isMedium ? "small" : "large"}
        onClick={handleSubmit}
        disabled={!name || !email || !message}
        sx={{
          textTransform: "none",
          color: "common.black",
        }}
      >
        Send Message
      </Button>
    </Stack>
  );
};
